import React from "react";
import { Link } from "react-router-dom";
import "./Welcome.css";
function Welcome() {
  return (
    <>
      <div className=" pt-lg-5 pb-lg-0  pt-4 pb-4  text-center our-hotel">
        <div className="xl:max-w-screen-xl lg:max-w-screen-lg  ps-4 pe-4 mx-auto ">
          <div className="row    ms-0 me-0">
            <div className="col-lg-6 lg:pb-0  pb-3 text-start">
              <h3 className="main-heading-font">
                Welcome to{" "}
                <span className="me-2  text-[#d0902e]">
                  The Majestic Hotel <br className="d-none d-lg-block" />
                </span>
                Where Coastal Charm Meets Timeless Elegance
              </h3>
              <p className="pt-4 main-paragraph-font-welcome">
                Located along the picturesque beachfront of Eastbourne lies
                The Majestic Hotel, a charming haven boasting comfortable accommodations
                that promise a delightful retreat. With a splendid terrace
                overlooking the glistening waters, a cozy restaurant, and a
                stylish bar, this hotel invites guests to indulge in leisure and
                relaxation.
              </p>
              <p className="pt-4 main-paragraph-font-welcome">
                Experience seaside serenity and hospitality at its finest at
                The Majestic Hotel, where every moment is infused with charm and
                relaxation.
              </p>
              <div className="text-center mt-4">
                <Link to="/seasonal-offers">
                  <button className="border-2 border-[#d0902e] pt-2 pb-2 ps-4 pe-4 text-[#d0902e] font-bold rounded-3xl hover:bg-[#d0902e] hover:text-[#ffffff] transition-all">
                    Explore
                  </button>
                </Link>
              </div>
            </div>
            <div className="col-lg-6  d-flex justify-center p-lg-4">
              <img src="/assets/sofa.jpg" alt="sofa"></img>
            </div>
          </div>
          <div className="row mt-12   ms-0 me-0">
            <div className="col-lg-6 order-2 order-lg-1 d-flex justify-center p-lg-4 mt-4 mt-lg-0">
              <img
                src="/assets/sesanal.jpg"
                alt="seasonal offers"
                className="img-fluid"
              />
            </div>
            <div className="col-lg-6 order-1 order-lg-2 pb-3 pb-lg-0  text-lg-start text-start d-flex flex-column justify-between">
              <div>
                <h3 className="main-heading-font sm:flex gap-2">
                  <p className="me-0 flex gap-3">
                    Our  {" "}
                    <span className="me-0 text-[#d0902e]">
                      Seasonal<br className="d-none d-lg-block" />
                    </span>
                  </p>
                  Offers
                </h3>
                <p className="pt-4 main-paragraph-font-welcome">
                  Experience the magic of the festive season at The Majestic Hotel in Eastbourne.
                  <br />
                  <br />
                  Celebrate Christmas and winter in style with our exclusive seasonal hotel packages, featuring luxury stays, festive dining, and special holiday events by the sea.Enjoy a traditional Christmas lunch, an elegant New Year’s Eve Gala Dinner, or a relaxing winter getaway in Eastbourne.
                  <br />
                  <br />
                  Whether you’re joining us for a cosy festive break or a memorable dining experience, The Majestic Hotel offers warmth, charm, and unforgettable moments this holiday season.
                </p>
              </div>
              <div className="text-center mt-10 lg:mt-0 lg:mb-10">
                <Link to="/seasonal-offers">
                  <button className="border-2 border-[#d0902e] pt-2 pb-2 ps-4 pe-4 text-[#d0902e] font-bold rounded-3xl hover:bg-[#d0902e] hover:text-[#ffffff] transition-all">
                    Explore
                  </button>
                </Link>
              </div>
            </div>
          </div>

        </div>
      </div>
    </>
  );
}

export default Welcome;
